module.exports = __webpack_public_path__ + "static/35gde-a563f61f15790eb6853a7c699179b918.gif";